/**
 * Powerup identifiers shared across game and cgame.
 * Reference: rerelease/g_items.cpp, game/src/inventory/playerInventory.ts
 */

export enum PowerupId {
  QuadDamage = 'quad',
  Invulnerability = 'invulnerability',
  EnviroSuit = 'enviro_suit',
  Rebreather = 'rebreather',
  Silencer = 'silencer',
  // New additions for demo playback and extended support
  PowerScreen = 'power_screen',
  PowerShield = 'power_shield',
  QuadFire = 'quad_fire',
  Invisibility = 'invisibility',
  Bandolier = 'bandolier',
  AmmoPack = 'ammo_pack',
  IRGoggles = 'ir_goggles',
  DoubleDamage = 'double_damage',
  SphereVengeance = 'sphere_vengeance',
  SphereHunter = 'sphere_hunter',
  SphereDefender = 'sphere_defender',
  Doppelganger = 'doppelganger',
  TagToken = 'tag_token',
  TechResistance = 'tech_resistance',
  TechStrength = 'tech_strength',
  TechHaste = 'tech_haste',
  TechRegeneration = 'tech_regeneration',
  Flashlight = 'flashlight',
  Compass = 'compass',
}
